export default __webpack_public_path__ + "static/media/Beard_7_C1.3e617841.svg";